// ProgressInquiryPageService.ts
import { axiosRequest } from './AxiosService';
import { ProgressInquiryPageResponse, ProgressInquiryPageResponseList } from '../type/response/ProgressInquiryPageResponse';
import { ProgressInquiryPageType } from '../pages/ProgressInquiry/data/ProgressInquiryPageType';

/**
 * 進捗照会ページデータを取得し、表示用の形式に変換して返す
 * @returns 進捗照会一覧データ、取得失敗時は空配列
 */
export const getProgressInquiryPageData = async (): Promise<ProgressInquiryPageType[]> => {
  try {
    const response = await axiosRequest<ProgressInquiryPageResponseList>(
      "/progressInquiryPage",
      "GET"
    );

    if (!Array.isArray(response)) {
      console.error("予期しないAPIレスポンス形式です:", response);
      return [];
    }

    // サーバーから取得したデータのフォーマットを変更する
    const formattedProgressList: ProgressInquiryPageType[] = response.map((response: ProgressInquiryPageResponse) => {
      const formattedProgress: ProgressInquiryPageType = {
        id: response.applicationEntry.id,
        applicationNumber: response.applicationEntry.number,
        submittedAt: response.applicationEntry.submittedAt,  // 申請日
        applicationType: response.applicationType.name || "", // 申請種別
        applicationFormat: response.application.name || "", // 申請書
        description:response.application.description || "", // 申請書小分類
        applicationStatus: response.applicationEntry.status, // ステータス
        applicantId: response.user.id, // 申請者Id
        applicant: `${response.user.lastName}${response.user.firstName}`, // 申請者
        isUrgent: response.applicationEntry.isExpress, // 急ぎ申請か否か
        userProfiles: Array.isArray(response.userProfiles)
          ? response.userProfiles.map(profile => ({
            key: profile.key,
            value: profile.value
          })) : [],
          activities: Array.isArray(response.activities)
          ? response.activities.map(act => ({
              id: act.id,
              activityStatus: act.status,
              activityName: act.applicationActivity.activityName,
              endAt: act.endAt,
              order: act.applicationActivity.activityOrder
            }))
          : [],
        userGroup: response.userGroup.map((group) => group.name),
        referent: response.referent
      };
      return formattedProgress;
    });

    return formattedProgressList;

  } catch (error) {
    console.error("進捗照会データの取得・整形に失敗しました:", error);
    return [];
  }
};